// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","agentsTable":"O3XzPZh2lz42h4VeNxXB","backoffice":"ITUsJyRK0gUe9cpfNhpw"};